/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realtime_Monitoring_ActiveInputs */

const en_realtime_monitoring_active = /** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-time Monitoring Active`)
};

const es_realtime_monitoring_active = /** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoreo en Tiempo Real Activo`)
};

const fr_realtime_monitoring_active = /** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveillance en temps réel active`)
};

const de_realtime_monitoring_active = /** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echtzeitüberwachung Aktiv`)
};

const id_realtime_monitoring_active = /** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemantauan Real-time Aktif`)
};

/** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */
const ja_realtime_monitoring_active = en_realtime_monitoring_active;

/** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */
const zh_realtime_monitoring_active = en_realtime_monitoring_active;

/** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */
const ar_realtime_monitoring_active = en_realtime_monitoring_active;

/** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */
const it_realtime_monitoring_active = en_realtime_monitoring_active;

/** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */
const ru_realtime_monitoring_active = en_realtime_monitoring_active;

/** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */
const pt_realtime_monitoring_active = en_realtime_monitoring_active;

/** @type {(inputs: Realtime_Monitoring_ActiveInputs) => LocalizedString} */
const ko_realtime_monitoring_active = en_realtime_monitoring_active;

/**
* | output |
* | --- |
* | "Real-time Monitoring Active" |
*
* @param {Realtime_Monitoring_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const realtime_monitoring_active = /** @type {((inputs?: Realtime_Monitoring_ActiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realtime_Monitoring_ActiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_realtime_monitoring_active(inputs)
	if (locale === "es") return es_realtime_monitoring_active(inputs)
	if (locale === "fr") return fr_realtime_monitoring_active(inputs)
	if (locale === "de") return de_realtime_monitoring_active(inputs)
	if (locale === "ja") return ja_realtime_monitoring_active(inputs)
	if (locale === "zh") return zh_realtime_monitoring_active(inputs)
	if (locale === "ar") return ar_realtime_monitoring_active(inputs)
	if (locale === "id") return id_realtime_monitoring_active(inputs)
	if (locale === "it") return it_realtime_monitoring_active(inputs)
	if (locale === "ru") return ru_realtime_monitoring_active(inputs)
	if (locale === "pt") return pt_realtime_monitoring_active(inputs)
	return ko_realtime_monitoring_active(inputs)
});